import { Component, Inject, OnInit, DOCUMENT } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/services/user.service';
import { UserData } from '../model/user-data';
import { UsersDataResponse } from '../model/users-data-response';
import { TranslateService } from '@ngx-translate/core';

import { MsalService } from '@azure/msal-angular';
import { CookieService } from 'ngx-cookie-service';
import { IdlePopupComponent } from '../idle-popup/idle-popup.component';
import { MatDialog } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SsoSecurityService } from 'src/app/services/sso-security.service';
@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    standalone: false
})
export class HeaderComponent implements OnInit {
   userData:UserData;
   user:UsersDataResponse;
  
  constructor(private router :Router,private userservice:UserService,public translate: TranslateService,private route:Router,
    @Inject(DOCUMENT) private document: Document,private authService: MsalService,private dialog:MatDialog,
    private authssoservice:SsoSecurityService) {
    this.userData=new UserData();
    this.user=new UsersDataResponse();
    translate.addLangs(['en', 'fr']);
    translate.setDefaultLang('en'); 
    this.userservice.profileUserData.subscribe( value => {
      this.user = value;
      this.userData=value.userData;
  });
  }

  ngOnInit(): void {
 this.userservice.getCurrentUser().subscribe(data=>{
   this.user=data;
   this.userData=data.userData;
   this.translate.use(this.userData.language.toLowerCase());
   

//   //  if(this.user){
//   //  this.userservice.getLoginUserData().subscribe(userdata => {
         
//   //   this.user = userdata;
//   //   this.userData = userdata.userData;
//   //   this.userservice.setCurrentUser(this.user);
   
//   // });
// }
  })

  }

  myProfile(){
    if(this.userData.roleId<4){
    this.router.navigate(['/dcn-esign/my-profile-dc',this.userData.sequenceNumber], { queryParams: { 'action': 'profile' }} );
  }else
      if(this.userData.roleId>3){
    this.router.navigate(['/dcn-esign/my-profile-store',this.userData.sequenceNumber], { queryParams: { 'action': 'profile' }} );
  }

}


logout(){

  this.userservice.updateLogoutStatus(this.user.userData.sequenceNumber).subscribe(data=>{
  this.userservice.setLogOut();
  this.authssoservice.logoutRedirect();
  // const loginRequest = {
  //   postLogoutRedirectUri: "http://localhost:4200/logoutapp"
  // //  loginHint: "Rakesh.Konduri@loblawdv.ca"
  // }
 //window.location.href ='https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/logoutapp';
 //window.location.href ='https://dcn-esign-np-gateway-dev.apps.pvtgfpte.ngco.com/scg-logout';

 //this.router.navigate(["/logoutapp"]);
//  const loginRequest = {
//  // scopes: ["user.read"],
//    //loginHint: this.userData.upn
// //  loginHint: "Rakesh.Konduri@loblawdv.ca"
// postLogoutRedirectUri:"http://localhost:4200/auth-callback"
// }
//   this.authService.logout();
 //window.location.href ='http://localhost:4200/logoutapp';

//  forkJoin([
  
//   window.location.href = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout", //observable 1
//   window.location.href = "https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/",
//   //window.location.href = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout"
// ]).subscribe(([response1, response2]) => {
//   // When Both are done loading do something
// });
//this.authService.logout();
  //window.location.href = "https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/"

//window.location.href = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout?post_logout_redirect_uri=https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/"
// window.location.href = environment.logouturl;
//  alert("midel")
//  window.location.href = "https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/"
//  alert("after")
//window.location.href = "https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout?post_logout_redirect_uri=https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/"
 //icrosoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout';
//this.router.navigateByUrl("/scg-logout?redirect=/logoutapp")

  //this.authService.loginRedirect();
 // this.router.navigate(["                                     "])
  //this.router.navigate(["https://login.microsoftonline.com/eaa6cb52-58d7-45cd-8bd6-b1d2a8e61312/oauth2/v2.0/logout"])
  // this.userservice.getSCGlogout().subscribe(data=>{
  //   console.log(data);
  //   this.userservice.getAzureLogout().subscribe(data=>{
  //     console.log(data);
  //   })
  // })
  // this.authService.logout().subscribe(s=>{
   //this.document.location.href ="https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/logoutapp";
 
  // })
  
 // https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/

  //window.location.href="https://login.microsoftonline.com/55ab44f3-be48-4bbb-bb8d-a860780fd8a8/oauth2/v2.0/logout";
 //this.document.location.href  = "https://login.microsoftonline.com/eaa6cb52-58d7-45cd-8bd6-b1d2a8e61312/oauth2/v2.0/logout

 //this.document.location.href ="https://dcn-esign-np-gateway-uat.apps.pvtgfpte.ngco.com/scg-logout?redirect=/logoutapp";
})
window.location.href = environment.logouturl;
}

}
